'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["dimensions", "Template"],
  _excluded2 = ["dimensions", "Template"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toScaledPercentage } from './DeviceConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTemplate = styled(props => {
  const {
      dimensions,
      Template
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(Template, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMin slice",
    viewBox: `0 0 ${dimensions.width} ${dimensions.height}`
  }, rest));
}).withConfig({
  displayName: "AbstractDeviceTemplate__StyledTemplate",
  componentId: "sc-1t7t5ho-0"
})(["height:1px;overflow:visible !important;padding-bottom:", ";pointer-events:none;position:relative;vertical-align:bottom;width:100%;z-index:1;@supports (display:grid){height:auto;padding-bottom:0;}"], props => toScaledPercentage(props.dimensions, 'height'));
const AbstractDeviceTemplate = props => {
  const {
      dimensions,
      Template
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  return /*#__PURE__*/_jsx(StyledTemplate, Object.assign({}, rest, {
    Template: Template,
    dimensions: dimensions
  }));
};
AbstractDeviceTemplate.propTypes = {
  children: PropTypes.node,
  dimensions: PropTypes.shape({
    Template: PropTypes.elementType.isRequired,
    top: PropTypes.number.isRequired,
    right: PropTypes.number.isRequired,
    bottom: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  }),
  Template: PropTypes.elementType
};
AbstractDeviceTemplate.defaultProps = {
  Template: StyledTemplate
};
export default AbstractDeviceTemplate;